import DashboardSideBarNavItemComponent from './DashboardSideBarNavItem.component';

export default function DashboardSideBarNavItemContainer({
  icon,
  title,
  active,
  onClick,
  subItems,
  isCollapsed,
  onExpandSidebar,
  badgeCount,
}) {
  return (
    <DashboardSideBarNavItemComponent
      icon={icon}
      title={title}
      active={active}
      onClick={onClick}
      subItems={subItems}
      isCollapsed={isCollapsed}
      onExpandSidebar={onExpandSidebar}
      badgeCount={badgeCount}
    />
  );
}
